import React from "react"
import { Layout } from "antd"
import DocumentTitle from "react-document-title"
import isEqual from "lodash/isEqual"
import memoizeOne from "memoize-one"
import { connect } from "dva"
import { ContainerQuery } from "react-container-query"
import classNames from "classnames"
import pathToRegexp from "path-to-regexp"
import Media from "react-media"
import Authorized, { reloadAuthorized } from "@/utils/Authorized"
import queryString from 'query-string'
import logo from "../assets/logo.png"
import Header from "./Header"
import Context from "./MenuContext"
import SiderMenu from "@/components/SiderMenu"
import moment from "moment"
import 'moment/locale/zh-cn'
import styles from "./BasicLayout.less"
import router from "umi/router"
import { domParentHasClass, os } from "@/utils/utils"

moment.locale("zh-cn")

const { Content } = Layout

const query = {
  "screen-xs": {
    maxWidth: 575,
  },
  "screen-sm": {
    minWidth: 576,
    maxWidth: 767,
  },
  "screen-md": {
    minWidth: 768,
    maxWidth: 991,
  },
  "screen-lg": {
    minWidth: 992,
    maxWidth: 1199,
  },
  "screen-xl": {
    minWidth: 1200,
    maxWidth: 1599,
  },
  "screen-xxl": {
    minWidth: 1600,
  },
}

class BasicLayout extends React.PureComponent {
  constructor(props) {
    super(props)
    this.getPageTitle = memoizeOne(this.getPageTitle)
    this.matchParamsPath = memoizeOne(this.matchParamsPath, isEqual)
    this.handleClick = this.handleClick.bind(this)
  }

  async componentDidMount() {
    // document.addEventListener("click", this.handleClick)
    // alert(os().isTablet)
    const {
      dispatch,
      location,
      route: { routes },
    } = this.props

    let { pathname, query } = location
    const { token, ...otherParam } = query
    dispatch({
      type: 'user/fetchFrequentEmployee',
      payload: { clinicId: localStorage.getItem('fulcrum-ancare-clinic-id') }
    })
    dispatch({
      type: "user/fetchCurrent",
    }).then((roles) => {
      reloadAuthorized()
      if (os().isTablet) {
        router.push('/ipad/personal')
        return
      }
      router.push({
        pathname,
        search: queryString.stringify(otherParam)
      })
      dispatch({
        type: "menu/getMenuData",
        payload: { routes, authority: localStorage.getItem('user-authority') ? JSON.parse(localStorage.getItem('user-authority')) : 'admin' },
      })
    })
  }

  // componentDidUpdate(preProps) {
  //   // After changing to phone mode,
  //   // if collapsed is true, you need to click twice to display
  //   const { collapsed, isMobile } = this.props
  //   if (isMobile && !preProps.isMobile && !collapsed) {
  //     this.handleMenuCollapse(false)
  //   }
  // }

  // componentWillUnmount() {
  //   document.removeEventListener("click", this.handleClick)
  // }

  handleClick(event) {
    event.stopPropagation()
    let target = event.target

    if (!domParentHasClass(target, "ant-layout-sider")) {
      this.handleMenuCollapse(true)
    }
  }

  getContext() {
    const { location, breadcrumbNameMap } = this.props
    return {
      location,
      breadcrumbNameMap,
    }
  }

  matchParamsPath = (pathname, breadcrumbNameMap) => {
    const pathKey = Object.keys(breadcrumbNameMap).find(key => pathToRegexp(key).test(pathname))
    return breadcrumbNameMap[pathKey]
  }

  getRouterAuthority = (pathname, routeData) => {
    let routeAuthority = ["noAuthority"]
    const getAuthority = (key, routes) => {
      routes.map(route => {
        if (route.path && route.path.indexOf(':id') > -1 && pathToRegexp(route.path).exec(key)) {
          routeAuthority = route.authority
        } else if (route.path === key) {
          routeAuthority = route.authority
        } else if (route.routes) {
          routeAuthority = getAuthority(key, route.routes)
        }
        return route
      })
      return routeAuthority
    }
    return getAuthority(pathname, routeData)
  }

  getPageTitle = (pathname, breadcrumbNameMap) => {
    const currRouterData = this.matchParamsPath(pathname, breadcrumbNameMap)

    if (!currRouterData) {
      return "安肯云门店"
    }
    const pageName = currRouterData.text

    return `${pageName} - 安肯云门店`
  }

  getLayoutStyle = () => {
    const { fixSiderbar, isMobile, collapsed, layout } = this.props
    if (fixSiderbar && layout !== "topmenu" && !isMobile) {
      return {
        paddingLeft: collapsed ? "60px" : "196px",
      }
    }
    return null
  }

  handleMenuCollapse = collapsed => {
    const { dispatch } = this.props
    dispatch({
      type: "global/changeLayoutCollapsed",
      payload: collapsed,
    })
  }

  render() {
    const {
      navTheme,
      layout: PropsLayout,
      children,
      location: { pathname },
      isMobile,
      menuData,
      breadcrumbNameMap,
      route: { routes },
      fixedHeader,
    } = this.props

    const isTop = PropsLayout === "topmenu"
    const routerConfig = this.getRouterAuthority(pathname, routes)
    const contentStyle = !fixedHeader ? { paddingTop: 0 } : {}
    const layout = (
      <Layout>
        {isTop && !isMobile ? null : (
          <SiderMenu
            logo={logo}
            theme={navTheme}
            onCollapse={this.handleMenuCollapse.bind(this)}
            menuData={menuData}
            isMobile={isMobile}
            {...this.props}
          />
        )}
        <Layout
          style={{
            ...this.getLayoutStyle(),
            minHeight: "100vh",
            overflow: "hidden"
          }}
        >
          {/* <Header
            menuData={menuData}
            handleMenuCollapse={this.handleMenuCollapse}
            logo={logo}
            isMobile={isMobile}
            {...this.props}
          /> */}
          <Content className={styles.content} style={contentStyle}>
            <Authorized authority={routerConfig} noMatch={<p></p>}>
              {children}
            </Authorized>
          </Content>
        </Layout>
      </Layout>
    )
    return (
      <React.Fragment>
        <DocumentTitle title={this.getPageTitle(pathname, breadcrumbNameMap)}>
          <ContainerQuery query={query}>
            {params => (
              <Context.Provider value={this.getContext()}>
                <div className={classNames(params)}>{layout}</div>
              </Context.Provider>
            )}
          </ContainerQuery>
        </DocumentTitle>
      </React.Fragment>
    )
  }
}

export default connect(({ global, setting, menu, user }) => ({
  collapsed: global.collapsed,
  layout: setting.layout,
  menuData: menu.menuData,
  userAuthority: user.userAuthority,
  breadcrumbNameMap: menu.breadcrumbNameMap,
  ...setting,
}))(props => {
  return (
    <Media query="(max-width: 599px)">
      {isMobile => <BasicLayout {...props} isMobile={isMobile} />}
    </Media>
  )
})
